module.exports = __webpack_public_path__ + "img/location_pin_3.57dffb95.png";